import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Select } from 'antd'

const AlumniEventRegistrationRibbon = ({
  filterValue,
  setFilterValue,
}) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [eventList, setEventList] = useState([])

  useEffect(() => {
    axios.post('/p/alumni/event/list/get', { 
      merchant_oid: merchantOid,
      per_page: 1000
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setEventList(response.data.events)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid])

  let statusItems = [
    {  
      value: 0, 
      label: '全部'
    },
    {
      value: 1,
      label: '未审核'
    },
    {
      value: 2,
      label: '通过'
    },
    {
      value: 3,
      label: '拒绝'
    }
  ]

  let eventitems = [
    {  
      value: '', 
      label: '全部'
    },
    ...eventList.map((item) => (
      {
        value: item.oid,
        label: item.name
      }
    ))
  ]

  const clickStatusFilter = (value) => {
    setFilterValue({ ...filterValue, status: value })
  }

  const clickEventFilter = (value) => {
    setFilterValue({ ...filterValue, event_oid: value })
  }

  return (
    <div className='ribbon-page'>
      <div className='ribbon-container'>
        <Select
          placeholder="审核状态"
          options={statusItems}
          style={{height: '32px', width: '200px'}}
          onChange={(value) => clickStatusFilter(value)}
        />
        <Select
          placeholder="所属活动"
          value={filterValue.event_oid || undefined}
          options={eventitems}
          style={{height: '32px', width: '200px'}}
          onChange={(value) => clickEventFilter(value)}
        />
      </div>
    </div>
  )
}

export default AlumniEventRegistrationRibbon
